import { useEffect } from 'react'
import shortid from 'shortid'

export default function useLerpWorker (lerp, manager, nodes, edges, displayEdges, stats, running) {
  const { lerpFactorRef } = stats

  useEffect(() => {
    const currenIterationId = lerp.iterationId
    let raf
    let isStopped = false

    function run () {
      lerp.run(
        lerpFactorRef.current,
        currenIterationId,
        nodes,
        edges,

        (result) => {
          if (!result) {
            raf = window.requestAnimationFrame(run)
          } else if (!isStopped && result.iterationId === currenIterationId) {
            manager.edgeFromPosition.set(result.neoEdges.edgeFroms)
            manager.edgeToPosition.set(result.neoEdges.edgeTos)
            manager.nodePositions.set(result.positions)

            lerpFactorRef.current = Math.max(
              lerpFactorRef.current - 0.0005,
              0.01
            )

            raf = window.requestAnimationFrame(run)
          }
        }
      )
    }

    if (running) run()

    return () => {
      if (raf) window.cancelAnimationFrame(raf)
      isStopped = true
      lerp.iterationId = shortid()
    }
  }, [
    running,
    lerp,
    nodes,
    edges,
    manager,
    lerpFactorRef
  ])
}
